export const PAYMENT_REDUCER_NAME = 'payment'
export const PAYMENT_METHODS_REDUCER_NAME = 'paymentMethods'
export const CHANGED_DEFAULT_PAYMENT_METHODS_REDUCER_NAME =
  'changedDefaultPaymentMethod'
export const DETACH_PAYMENT_METHODS_REDUCER_NAME = 'detachPaymentMethod'
export const SETUP_INTENT_REDUCER_NAME = 'setupIntent'
export const SELECTED_PAYMENT_METHOD_REDUCER_NAME = 'selectedPaymentMethod'
export const INVOICE_REDUCER_NAME = 'invoice'
